
import { axios, BaseApiUrl ,BaseUrl} from '../axios_config';


export const getDepartmentList = params => {
    return axios.get(`${BaseApiUrl}/ProductionReport/GetDepartment`, { params: params });
};

export function GetwarehouseInOutProdutionOperationTypeList(params) {
    return axios.post(`${BaseApiUrl}/Util/GetwarehouseInOutProdutionOperationTypeList`, params);
}

export function GetWarehouseInOutProdutionReport(params) {
    return axios.post(`${BaseApiUrl}/ProductionReport/GetWarehouseInOutProdutionReport`, params);
}

export function ExportWarehouseInOutProdutionReport(params) {
    return axios.post(`${BaseApiUrl}/ProductionReport/ExportWarehouseInOutProdutionReport`, params);
}